/**
 * 分享构建（publish:completed）专用：已完成页内链下钻所需路由。
 */
export const SHARE_COMPANION_ROUTES = [
  {
    path: '/design-test/app-mini-pmsmart-functions',
    name: 'DesignTestAppMiniPmsmartFunctionsHub',
    component: () =>
      import('../design-test-views/app-mini-program/DesignTestAppMiniPmsmartFunctionsHubView.vue'),
  },
  {
    path: '/design-test/app-mini-concrete-ticket-ai-list-m6854',
    name: 'DesignTestConcreteTicketAiListM6854',
    component: () =>
      import('../design-test-views/app-mini-program/DesignTestConcreteTicketAiListM6854View.vue'),
  },
  {
    path: '/design-test/app-mini-cable-list-m6854',
    name: 'DesignTestCableListM6854',
    redirect: (to) => {
      const q = { from: 'cable-list' };
      const mid = to.query.meteringReelId;
      const midStr =
        typeof mid === 'string'
          ? mid.trim()
          : Array.isArray(mid) && typeof mid[0] === 'string'
            ? mid[0].trim()
            : '';
      if (midStr) q.meteringReelId = midStr;
      const ms = to.query.meteringScreen ?? to.query.screen;
      const sc = ms == null ? '' : String(Array.isArray(ms) ? ms[0] : ms).trim();
      if (sc !== '') q.screen = sc;
      return { name: 'DesignTestCableReelMeteringHub', query: q };
    },
  },
  {
    path: '/design-test/app-mini-cable-metering',
    redirect: (to) => ({
      path: '/design-test/app-mini-cable-reel-metering',
      query: to.query,
      hash: to.hash,
    }),
  },
  {
    path: '/design-test/app-mini-cable-reel-metering',
    alias: ['/design-test/app-mini-cable-reel-metering/'],
    name: 'DesignTestCableReelMeteringHub',
    component: () =>
      import('../design-test-views/app-mini-program/DesignTestCableReelMeteringHubView.vue'),
  },
  {
    path: '/design-test/app-mini-cable-reel-review',
    alias: ['/design-test/app-mini-cable-reel-review/'],
    name: 'DesignTestCableReelReviewHub',
    component: () =>
      import('../design-test-views/app-mini-program/DesignTestCableReelReviewHubView.vue'),
  },
  {
    path: '/design-test/app-mini-material-inbound',
    name: 'DesignTestAppMiniMaterialInbound',
    component: () =>
      import('../design-test-views/app-mini-program/DesignTestAppMiniMaterialInboundView.vue'),
  },
  {
    path: '/design-test/app-mini-material-requisition',
    name: 'DesignTestAppMiniMaterialRequisition',
    component: () =>
      import('../design-test-views/app-mini-program/DesignTestAppMiniMaterialRequisitionView.vue'),
  },
  {
    path: '/design-test/dt-30-construction-log',
    name: 'DesignTest30ConstructionLogList',
    component: () =>
      import('../design-test-views/app-mini-program/DesignTest30ConstructionLogListView.vue'),
  },
  {
    path: '/design-test/dt-30-construction-log-templates',
    name: 'DesignTest30ConstructionLogTemplate',
    component: () =>
      import('../design-test-views/app-mini-program/DesignTest30ConstructionLogTemplateView.vue'),
  },
  {
    path: '/design-test/dt-30-construction-log-upload',
    name: 'DesignTest30ConstructionLogUpload',
    component: () =>
      import('../design-test-views/app-mini-program/DesignTest30ConstructionLogUploadView.vue'),
  },
  {
    path: '/design-test/dt-30-construction-log-detail',
    name: 'DesignTest30ConstructionLogDetail',
    component: () =>
      import('../design-test-views/app-mini-program/DesignTest30ConstructionLogDetailView.vue'),
  },
  {
    path: '/design-test/dt-30-construction-log-edit',
    name: 'DesignTest30ConstructionLogEdit',
    component: () =>
      import('../design-test-views/app-mini-program/DesignTest30ConstructionLogEditView.vue'),
  },
  {
    path: '/design-test/dt-31-material-plan',
    name: 'DesignTest31MaterialPlanList',
    component: () =>
      import('../design-test-views/app-mini-program/DesignTest31MaterialPlanListView.vue'),
  },
  {
    path: '/design-test/dt-31-material-plan-edit',
    name: 'DesignTest31MaterialPlanEdit',
    component: () =>
      import('../design-test-views/app-mini-program/DesignTest31MaterialPlanEditView.vue'),
  },
  {
    path: '/design-test/dt-31-app-mini-functions',
    name: 'DesignTest31AppMiniPmsmartFunctionsHub',
    component: () =>
      import('../design-test-views/app-mini-program/DesignTest31AppMiniPmsmartFunctionsHubView.vue'),
  },
  {
    path: '/design-test/dt-21-mep-cable-inbound-list',
    name: 'DesignTest21MepCableInboundList',
    component: () => import('../design-test-views/DesignTest21MepCableInboundListView.vue'),
  },
  {
    path: '/design-test/dt-38-app-mini-functions',
    name: 'DesignTest38AppMiniPmsmartFunctionsHub',
    component: () =>
      import('../completed-page-views/dt38-app-mini-functions-v2/DesignTest38AppMiniPmsmartFunctionsHubView.vue'),
  },
  {
    path: '/design-test/dt-38-material-plan',
    name: 'DesignTest38MaterialPlanList',
    component: () =>
      import('../completed-page-views/dt38-app-mini-functions-v2/DesignTest38MaterialPlanListView.vue'),
  },
  {
    path: '/design-test/dt-38-material-plan-edit',
    name: 'DesignTest38MaterialPlanEdit',
    component: () =>
      import('../completed-page-views/dt38-app-mini-functions-v2/DesignTest38MaterialPlanEditView.vue'),
  },
  {
    path: '/design-test/dt-38-mep-app',
    redirect: { name: 'DesignTest38AppMiniPmsmartFunctionsHub' },
  },
  {
    path: '/design-test/dt-41-app-mini-functions',
    name: 'DesignTest41AppMiniPmsmartFunctionsHub',
    component: () =>
      import('../completed-page-views/dt41-app-mini-functions-v3/DesignTest41AppMiniPmsmartFunctionsHubView.vue'),
  },
  {
    path: '/design-test/dt-41-material-plan',
    name: 'DesignTest41MaterialPlanList',
    component: () =>
      import('../completed-page-views/dt41-app-mini-functions-v3/DesignTest41MaterialPlanListView.vue'),
  },
  {
    path: '/design-test/dt-41-material-plan-edit',
    name: 'DesignTest41MaterialPlanEdit',
    component: () =>
      import('../completed-page-views/dt41-app-mini-functions-v3/DesignTest41MaterialPlanEditView.vue'),
  },
  {
    path: '/design-test/dt-41-mep-app',
    redirect: { name: 'DesignTest41AppMiniPmsmartFunctionsHub' },
  },
  {
    path: '/design-test/dt-53-drawing-model-analysis',
    name: 'DesignTest53DrawingModelAnalysis',
    component: () => import('../design-test-views/DesignTest53DrawingModelAnalysisView.vue'),
  },
];
